import React from 'react';
import { Redirect, Switch } from 'react-router-dom';
import Authorize from './components/auth/authorize/index';
import { ROLES } from './components/auth/roles';

const AppRedirect = () => (
  <Switch>
    <Authorize roles={[ROLES.OWNER]}>
      <Redirect from="/" to="/admin" />
    </Authorize>
  </Switch>
);

export default AppRedirect;
